import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/* Einstellungen → Graduierung (22.09.2026, Regelwerk): je Gürtelstufe
   Trainings, Haltezeit (Tage seit letzter Graduierung) und Streifen, die
   vor der Prüfung vergeben sein müssen. 0 = Kriterium aus. Speichern über
   den gemeinsamen Button oben (settings.belt_progression / settings.graduierung). */

const num = (v) => (v === '' || v === null || v === undefined ? 0 : Math.max(0, parseInt(v, 10) || 0));

export default function GraduierungRegelnTab({ settings, setSettings, isAdmin }) {
  const stufen = settings.belt_progression || [];
  const konf = settings.graduierung || { streifen_je_gurt: 4 };

  const setStufe = (i, feld, wert) => setSettings((p) => {
    const liste = [...(p.belt_progression || [])];
    liste[i] = { ...liste[i], [feld]: feld === 'label' || feld === 'color' ? wert : num(wert) };
    return { ...p, belt_progression: liste };
  });

  return (
    <div className="space-y-4" data-testid="graduierung-regeln">
      <Card className="border-border/60">
        <CardHeader className="pb-2"><CardTitle className="text-base">Streifen</CardTitle></CardHeader>
        <CardContent className="grid sm:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="streifen-je-gurt">Streifen je Gürtel</Label>
            <Input id="streifen-je-gurt" type="number" min={0} max={10} value={konf.streifen_je_gurt ?? 4} disabled={!isAdmin}
              onChange={(e) => setSettings((p) => ({ ...p, graduierung: { ...(p.graduierung || {}), streifen_je_gurt: num(e.target.value) } }))}
              data-testid="streifen-je-gurt" />
            <p className="text-xs text-muted-foreground mt-1">Trainer vergeben Streifen in der Graduierungs-Übersicht; bei der Beförderung werden sie auf 0 gesetzt.</p>
          </div>
        </CardContent>
      </Card>

      <Card className="border-border/60">
        <CardHeader className="pb-2"><CardTitle className="text-base">Voraussetzungen je Stufe</CardTitle></CardHeader>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border/60">
                  {['Stufe', 'Trainings gesamt', 'Haltezeit (Tage)', 'Streifen vorher', 'Farbe'].map((h) => (
                    <th key={h} className="text-left p-3 text-xs font-semibold text-muted-foreground">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {stufen.map((s, i) => (
                  <tr key={s.key} className="border-b border-border/30" data-testid={`regel-${s.key}`}>
                    <td className="p-3">
                      <div className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full border border-border flex-shrink-0" style={{ background: s.color || '#eee' }} />
                        <Input value={s.label || ''} disabled={!isAdmin} onChange={(e) => setStufe(i, 'label', e.target.value)} className="h-8 max-w-[200px]" />
                      </div>
                      <p className="text-[10px] text-muted-foreground mt-1 font-mono">{s.key}</p>
                    </td>
                    <td className="p-3"><Input type="number" min={0} value={s.trainings_required ?? 0} disabled={!isAdmin || i === 0} onChange={(e) => setStufe(i, 'trainings_required', e.target.value)} className="h-8 w-24" /></td>
                    <td className="p-3"><Input type="number" min={0} value={s.min_tage ?? 0} disabled={!isAdmin || i === 0} onChange={(e) => setStufe(i, 'min_tage', e.target.value)} className="h-8 w-24" /></td>
                    <td className="p-3"><Input type="number" min={0} max={konf.streifen_je_gurt ?? 4} value={s.min_streifen ?? 0} disabled={!isAdmin || i === 0} onChange={(e) => setStufe(i, 'min_streifen', e.target.value)} className="h-8 w-24" /></td>
                    <td className="p-3"><Input type="color" value={s.color || '#eeeeee'} disabled={!isAdmin} onChange={(e) => setStufe(i, 'color', e.target.value)} className="h-8 w-12 p-1" /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-xs text-muted-foreground p-3">Die erste Stufe ist der Einstieg und hat keine Voraussetzungen. „Trainings gesamt" zählt alle Check-ins seit Beginn (inkl. Octiv-Import). Haltezeit zählt ab der letzten Graduierung im CRM — Mitglieder ohne Datum gelten als erfüllt.</p>
        </CardContent>
      </Card>
    </div>
  );
}
